import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface AuthInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  icon: LucideIcon;
  error?: string;
}

const AuthInput: React.FC<AuthInputProps> = ({ label, icon: Icon, error, ...props }) => {
  return (
    <div>
      <Label className="block mb-1.5">
        {label}
      </Label>
      <div className="relative">
        <Input
          {...props}
          className={cn(
            "pl-11",
            error && "border-destructive focus-visible:ring-destructive"
          )}
        />
        <Icon className="w-5 h-5 text-gray-400 absolute left-3 top-3.5" />
      </div>
      {error && (
        <p className="mt-1 text-sm text-destructive">{error}</p>
      )}
    </div>
  );
};

export default AuthInput